module.exports = __webpack_public_path__ + "static/pic-98ffacc38ed818c19a3ce244de3549bb.jpg";